import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'

import Copy from '../../util/Copy'

@inject('auth')
@observer
export default class SignupCode extends Component {

  getCode() {
    const { reseller_team } = this.props.auth.user

    return (
`<div id="showcase-trial" data-plan="new_premium" data-rate="monthly" data-reseller="${reseller_team.id}"></div>
<script src="${process.env.ADMIN_URL}/dist/trial.js"></script>`
    )
  }

  render() {
    const code = this.getCode()
    return (
      <div className="container padded order">
        <div className="container">
          <div className="panel full padded">
            <h2 className="title">
              Signup Form Embed
            </h2>

            <p>
              Create a page in WordPress and paste in this code to start accepting
              new signups.
            </p>

            <div className="container">
              <pre className="signup-code">{code}</pre>
            </div>

            <Copy text={code} className="button big shadowed"/>

          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/Orders/SignupCode.js